'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _authTokenActions = require('actions/authTokenActions');

var _userActions = require('actions/userActions');

var _userActions2 = require('../actions/userActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _authTokenActions.AUTH_TOKEN_PROVIDED:
            return (0, _extends3.default)({}, state, {
                authorization: {
                    token: action.authToken
                },
                isTokenProvided: true
            });
        case _authTokenActions.AUTH_TOKEN_RECEIVED:
            return (0, _extends3.default)({}, state, {
                authorization: {
                    token: action.authToken
                }
            });
        case _userActions.USER_COMPLETE:
            return (0, _extends3.default)({}, state, {
                isG2G: true,
                prompt: true
            });
        case _userActions.HIDE_USER_COMPLETE_PROMPT:
            return (0, _extends3.default)({}, state, {
                prompt: false
            });
        case _userActions2.CURRENT_FLIGHT_CHECK_PASSENGER:
            return (0, _extends3.default)({}, state, {
                flightCheckPassengerId: action.flightCheckPassengerId
            });
        case _userActions2.IS_ZERO_SCHEDULE_FLOW:
            return (0, _extends3.default)({}, state, {
                isZeroScheduleFlow: action.isZeroScheduleFlow
            });
        default:
            return state;
    }
}

exports.default = user;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/user.js
// module id = 1405
// module chunks = 0